import { useQuery } from "@tanstack/react-query";
import type { EnhancedPOIs } from "@local-logic/client";
import { useLocalLogic } from "~/context/LocalLogicProvider";
import {
  enhancedPoisKeys,
  type EnhancedPoisResponse,
} from "~/features/enhancedPois";

type Options = {
  lat?: number;
  lng?: number;
  geogId?: string;
  include?: EnhancedPOIs[];
  limit?: number;
  radius?: number;
  buffer?: number;
  attemptMinimum?: number;
};

export function useEnhancedPois({
  lat,
  lng,
  geogId,
  include,
  // 30 is the default limit for POIs when getting combined POI categories
  limit = 30,
  radius = 2000,
  buffer = 0,
  attemptMinimum,
}: Options) {
  const { client } = useLocalLogic();

  const options: Options = {
    limit,
    include,
    attemptMinimum,
  };

  if (geogId) {
    options.geogId = geogId;
    options.buffer = buffer;
  } else {
    options.lat = lat;
    options.lng = lng;
    options.radius = radius;
  }

  return useQuery({
    queryKey: enhancedPoisKeys.list(options),
    queryFn: async () =>
      client.getEnhancedPois(options as unknown as EnhancedPoisResponse),
    staleTime: Infinity,
    enabled:
      !!options &&
      !!options.include?.length &&
      (!!geogId || (!!options.lat && !!options.lng)),
  });
}
